import { useMemo } from 'react';
import { IContact } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import { getRoleDisplayLabel } from 'src/common/roleRegistry/roleRegistryHelpers';

const NO_NAME_FALLBACK: string = '(no name)';

export interface ContactDisplay {
  fullName: string;
  roleLabels: string[];
}

export const useContactDisplay = (contact: IContact): ContactDisplay => {
  const fullName: string = useMemo(() => {
    const nameParts: string[] = [contact.firstname, contact.lastname].filter(
      (part: string | null | undefined): part is string => Boolean(part)
    );

    if (nameParts.length === 0) {
      return NO_NAME_FALLBACK;
    }

    return nameParts.join(' ');
  }, [contact.firstname, contact.lastname]);

  const roleLabels: string[] = useMemo(() => {
    const labels: string[] = [];

    for (const wrapper of contact.roles) {
      const roleName: string | undefined = wrapper.role?.name;

      if (roleName) {
        labels.push(getRoleDisplayLabel(roleName));
      }
    }

    return labels;
  }, [contact.roles]);

  return { fullName, roleLabels };
};
